export default __webpack_public_path__ + "assets/b8dd151e7f4655b45a98798d5ef73e7f.jpg";